@if (workersAvailable.length > 0) {
  <div role="region" aria-label="Worker selection">
    <h4 class="cbw-resource-title" id="worker-selection-heading">
      {{ widgetResourceHeadingTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}
    </h4>
    <div id="worker-selection-description" class="visually-hidden">
      Select a worker for your appointment. Use Tab to navigate between options and press Enter or Space to select.
    </div>
    <form #workerForm="ngForm">
      <div class="worker-container" role="radiogroup" aria-labelledby="worker-selection-heading" aria-describedby="worker-selection-description">
        <div class="row cbw-worker-card-container">
          @if (workersAvailable.length > 1 && showEgalWer === true) {
            <div class="col-lg-6 col-md-6 col-sm-6 calenso-col">
              <div 
                class="row cbw-worker-card" 
                (click)="selectWorker(0);" 
                (keydown.enter)="selectWorker(0);"
                (keydown.space)="selectWorker(0); $event.preventDefault()"
                [ngClass]="{'cbw-active-worker-card': 0 === appointmentState.worker}"
                tabindex="0"
                role="radio"
                [attr.aria-checked]="0 === appointmentState.worker"
                [attr.aria-label]="(widgetAnyoneLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) + ' - ' + (widgetAnyoneDescTemplate | translation: templateContent.TEMPLATE_CONTENT: lang)"
                [attr.aria-describedby]="isExceptionEnabled ? 'exception-selection' : null"
              >
                <div class="avatar col-3">
                  <img
                    alt=""
                    class="cbw-avatar"
                    src="{{ baseUrl }}/img/sample-avatar.png"
                    aria-hidden="true"
                  />
                </div>
                <div class="cbw-detail_description col-6">
                  <div
                    class="cbw-worker-name"
                    [innerHTML]="(widgetAnyoneLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"
                  ></div>
                  <div
                    class="cbw-function"
                    [innerHTML]="(widgetAnyoneDescTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"
                  ></div>
                  @if (partner?.is_widget_anyone_exception_enabled === 1) {
                    <button 
                      type="button"
                      class="cbw-exception" 
                      (click)="toggleException(); $event.stopPropagation()"
                      (keydown.enter)="toggleException(); $event.stopPropagation()"
                      (keydown.space)="toggleException(); $event.stopPropagation(); $event.preventDefault()"
                      [attr.aria-label]="'Toggle exception selection for anyone option'"
                      [attr.aria-expanded]="isExceptionEnabled"
                      tabindex="0"
                    >
                      {{ 'appointments.step2.exception' | translate }}
                    </button>
                  }
                </div>
                <div class="col-3 text-end">
                  <app-cw-radio-tick-button
                    [color]="0 === appointmentState.worker ? widgetColorConf.widget_header_active_color : ''"
                    [checked]="0 === appointmentState.worker"
                    [attr.aria-hidden]="true"
                  />
                </div>
              </div>
            </div>
          }
          @for (worker of workersAvailable; track worker; let index = $index) {
            <div class="col-lg-6 col-md-6 col-sm-6 calenso-col position-relative">
              @if (isExceptionEnabled) {
                <div class="position-absolute exception-selection cbw-exception-selection">
                  <app-cw-checkbox
                    id="{{ 'cf-' + worker.id }}"
                    name="{{ 'cf-' + worker.id }}"
                    [attr.aria-label]="'Select worker ' + (worker.is_resource === 0 ? worker.resource_name : (worker | translation: 'resource_name': lang))"
                    [(fieldNgModel)]="worker.checked"
                    (selectionChange)="onSelectCheckbox($event.event,worker.uuid)"
                    tabindex="0"
                  />
                </div>
              }
              <div
                class="row cbw-worker-card"
                (click)="!isExceptionEnabled && selectWorker(worker.id);"
                (keydown.enter)="!isExceptionEnabled && selectWorker(worker.id);"
                (keydown.space)="!isExceptionEnabled && selectWorker(worker.id); $event.preventDefault()"
                [ngClass]="{
                  'cbw-active-worker-card' : worker.id === appointmentState.worker,
                  'cbw-disabled-worker-card': isExceptionEnabled
                 }"
                [tabindex]="isExceptionEnabled ? -1 : 0"
                role="radio"
                [attr.aria-checked]="worker.id === appointmentState.worker"
                [attr.aria-label]="(worker.is_resource === 0 ? worker.resource_name : (worker | translation: 'resource_name': lang)) + (worker.is_resource === 0 ? (worker.job_title ? ' - ' + worker.job_title : '') : (worker.description ? ' - ' + worker.description : ''))"
                [attr.aria-describedby]="isExceptionEnabled ? 'exception-selection' : null"
                [attr.aria-disabled]="isExceptionEnabled"
              >
                <div class="avatar col-3">
                  @if (worker.avatar !== null) {
                    <img
                      alt=""
                      #image
                      class="cbw-avatar"
                      src="{{ workerAvatarUrl }}{{ worker.uuid }}/thumb_{{ worker.avatar }}"
                      (error)="image.src= baseUrl + '/img/sample-avatar.png'"
                      aria-hidden="true"
                    />
                  }
                  @if (worker.avatar === null) {
                    <img
                      alt=""
                      class="cbw-avatar"
                      src="{{ baseUrl }}/img/sample-avatar.png"
                      aria-hidden="true"
                    />
                  }
                </div>

                <div class="cbw-detail_description col-7" role="listitem">
                  <div class="cbw-worker-name" role="heading" aria-level="3">
                    @if (worker.is_resource === 0) {
                      {{ worker.resource_name }}
                    } @else {
                      {{ worker | translation: 'resource_name': lang }}
                    }
                  </div>

                  @if (worker.is_resource === 0 && worker.job_title?.trim()) {
                    <div
                      class="cbw-function"
                      [innerHTML]="(worker | translation: 'job_title': lang) | trustHtml"
                    ></div>
                  } @else if (worker.is_resource !== 0 && worker.description?.trim()) {
                    <div
                      class="cbw-function"
                      [innerHTML]="(worker | translation: 'description': lang) | trustHtml"
                    ></div>
                  }

                  @let displayStore = getSelectedStore(worker);
                  @if (partner?.widget_show_resource_store_name === 1 && displayStore) {
                    <div class="cbw-worker-store-location" role="listitem">
                      <span class="cbw-worker-store-location-name">{{ displayStore | translation: 'name' : lang }}</span>
                      @if (displayStore.is_online === 0) {
                        <span class="cbw-worker-store-location-separator">,&nbsp;</span>
                        <span class="cbw-worker-store-location-address whitespace-pre-line">
                          @let addressInput = {
                            street: displayStore.street,
                            zip: displayStore.zip,
                            city: displayStore.city,
                            country: displayStore.country | translation: 'name' : lang,
                            country_code: displayStore.country?.identifier
                          };
                          {{ addressInput | addressFormat: 'single' }}
                        </span>
                      }
                    </div>
                  }

                  @if (worker?.attributes?.length) {
                    @for (attribute of worker.attributes; track attribute.uuid) {
                      @if (attribute.type === 'select') {
                        <div class="attribute-container cbw-attribute-container">
                          <div class="cbw-attribute">
                            {{ attribute | translation: 'name': lang }}:
                          </div>
                          <div class="attribute-value-section">
                            @for (value of attribute.attributes_values; track value.uuid; let last = $last) {
                              <div class="attribute-value-img">
                                @if (value.icon_url !== null) {
                                  <img
                                    #image
                                    class="cbw-attribute-icon"
                                    alt="{{ value.value }}"
                                    src="{{ value.icon_url }}"
                                    (error)="image.src= baseUrl + '/img/sample-avatar.png'"
                                  />
                                }
                                <div class="cbw-attribute-value">
                                  {{ value | translation: 'value' : lang }}
                                  @if (!last) { | }
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      } @else {
                        <div class="cbw-attribute cbw-attribute-container">
                          {{ attribute | translation: 'name': lang }}:
                          @if (attribute.attributes_values?.length) {
                            {{ +attribute.attributes_values[0].value === 1 ? ( 'yes' | translate ): ( 'no' | translate ) }}
                          }
                        </div>
                      }
                    }
                  }
                </div>

                <div class="col-2 text-end">
                  <app-cw-radio-tick-button
                    [color]="worker.id === appointmentState.worker ? widgetColorConf.widget_header_active_color : ''"
                    [checked]="worker.id === appointmentState.worker"
                    [attr.aria-hidden]="true"
                  />
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      @if (showStepValidationError() && appointmentState.worker === null) {
        <div
          id="cbw-worker-validation-error"
          class="cbw-global-step-error cbw-worker-step-error"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div class="cbw-step-error-text">
            {{ stepErrorTemplate ? (stepErrorTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) : ('alert_messages.next_step_error_worker' | translate) }}
          </div>
        </div>
      }

      <div class="wizard-footer clearfix" role="navigation" aria-label="Navigation buttons">
        <div class="row margin-x-0">
          <div class="col-4 d-flex align-items-center justify-content-start">
            @if (!isWhitelabel()) {
              <div class="d-md-none">
                <img
                  alt="Logo"
                  src="{{ environment.deployUrl }}/assets/images/{{ environment.footerLogoUrl }}"
                  width="100">
              </div>
            }
          </div>
          <div class="col-4 d-flex align-items-center justify-content-center">
            @if (!isWhitelabel()) {
              <div class="d-none d-md-block">
                <img
                  alt="Logo"
                  src="{{ environment.deployUrl }}/assets/images/{{ environment.footerLogoUrl }}"
                  width="100">
              </div>
            }
          </div>
          <div class="col-4 d-flex align-items-center justify-content-end next-btn-custom-right-padding">
            <calenso-button
              type="secondary"
              id="cbw-prev-button"
              [text]="previousButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
              (clickEvent)="previousNavigation(appointmentConstant.APPOINTMENT)"
              placement="left"
              [widgetColorConf]="widgetColorConf"
              [attr.aria-label]="'Go to previous step'"
              tabindex="0"
            />
            <calenso-button
              type="primary"
              id="cbw-next-button"
              class="ms-2"
              [text]="nextButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
              (clickEvent)="onNextButtonClick()"
              [disabled]="+partner?.widget_buttons_always_enabled === 1 ? false : appointmentState.worker === null"
              placement="right"
              [widgetColorConf]="widgetColorConf"
              [attr.aria-label]="'Go to next step' + (appointmentState.worker === null ? ' - Worker selection required' : '')"
              [attr.aria-describedby]="showStepValidationError() && appointmentState.worker === null ? 'cbw-worker-validation-error' : null"
              tabindex="0"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
} @else {
  <!--
    No bookable resource for the chosen service. Without this branch the whole template — the
    back button included — rendered nothing, leaving the visitor stuck on an empty step.
  -->
  <!--
    Title only: the back button below lets the visitor pick a different service, so telling them
    to contact the provider directly would overstate the dead end.
  -->
  <app-new-alert
    type="warning"
    title="{{ 'common.booking_unavailable' | translate }}"
    customClass="mt-3 mb-3"
  />

  <div class="wizard-footer clearfix" role="navigation" aria-label="Navigation buttons">
    <div class="row margin-x-0">
      <div class="col-12 d-flex align-items-center justify-content-end next-btn-custom-right-padding">
        <calenso-button
          type="secondary"
          id="cbw-prev-button"
          [text]="previousButtonTemplate | translation: templateContent.TEMPLATE_CONTENT: lang"
          (clickEvent)="previousNavigation(appointmentConstant.APPOINTMENT)"
          placement="left"
          [widgetColorConf]="widgetColorConf"
          tabindex="0"
        />
      </div>
    </div>
  </div>
}
